var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.968,
    height: 59.968,
    viewBox: "0 0 59.968 59.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_ranking",
    "data-name": "vuesax/linear/ranking",
    transform: "translate(-492 -636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ranking",
    transform: "translate(492 636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.666,0H5A5.012,5.012,0,0,0,0,5V19.989H16.666Z",
    transform: "translate(4.997 34.981)",
    fill: "none",
    stroke: "#0098da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M11.669,0H5A5.012,5.012,0,0,0,0,5V29.984H16.666V5A5,5,0,0,0,11.669,0Z",
    transform: "translate(21.639 24.987)",
    fill: "none",
    stroke: "#0098da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M11.669,0H0V12.493H16.666V5A5.012,5.012,0,0,0,11.669,0Z",
    transform: "translate(38.305 42.478)",
    fill: "none",
    stroke: "#0098da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(22.473 4.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M8.811,1.065l1.324,2.649a1.51,1.51,0,0,0,1.049.775l2.4.4c1.524.25,1.9,1.374.8,2.449L12.509,9.211a1.6,1.6,0,0,0-.4,1.349l.525,2.3c.425,1.824-.55,2.524-2.149,1.574L8.236,13.109a1.543,1.543,0,0,0-1.474,0L4.513,14.433c-1.6.949-2.574.25-2.149-1.574l.525-2.3a1.574,1.574,0,0,0-.4-1.349L.64,7.362c-1.1-1.1-.75-2.2.8-2.449l2.4-.4a1.665,1.665,0,0,0,1.049-.775L6.212,1.09C6.937-.359,8.086-.359,8.811,1.065Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#0098da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H59.968V59.968H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoting);
export default __webpack_public_path__ + "static/media/voting.59754e01619e11d613704e98832f4709.svg";
export { ForwardRef as ReactComponent };